function initTrendingBar(bar, scroll, prev, next) {
  const step = 220;

  function updateArrows() {
    const atStart = scroll.scrollLeft <= 0;
    const atEnd = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 1;
    prev[atStart ? 'setAttribute' : 'removeAttribute']('data-at-edge', '');
    next[atEnd ? 'setAttribute' : 'removeAttribute']('data-at-edge', '');
  }

  function checkOverflow() {
    bar.classList.toggle('is-overflowing', scroll.scrollWidth > scroll.clientWidth);
    updateArrows();
  }

  prev.addEventListener('click', function () {
    scroll.scrollLeft -= step;
  });
  next.addEventListener('click', function () {
    scroll.scrollLeft += step;
  });
  scroll.addEventListener('scroll', updateArrows, {passive: true});
  window.addEventListener('resize', checkOverflow, {passive: true});
  checkOverflow();
}

function initCookieBanner(banner, acceptBtn, rejectBtn) {
  if (localStorage.getItem('cookie-consent')) return;

  setTimeout(function () {
    banner.removeAttribute('hidden');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        banner.classList.add('is-visible');
      });
    });
  }, 900);

  function dismiss(value) {
    banner.classList.remove('is-visible');
    localStorage.setItem('cookie-consent', value);
    setTimeout(function () {
      banner.setAttribute('hidden', '');
    }, 350);
  }

  acceptBtn.addEventListener('click', function () {
    dismiss('accepted');
  });

  rejectBtn.addEventListener('click', function () {
    dismiss('rejected');
  });
}

function initSideNav(btn, panel, backdrop, closeBtn) {
  let lastFocused = null;

  function openNav() {
    lastFocused = document.activeElement instanceof HTMLElement ? document.activeElement : btn;
    panel.classList.remove('is-hovered');
    panel.classList.add('is-open');
    backdrop.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    panel.removeAttribute('inert');
    btn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      closeBtn.focus();
    });
  }

  function closeNav() {
    panel.classList.remove('is-open', 'is-hovered');
    backdrop.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('inert', '');
    btn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocused instanceof HTMLElement) {
      lastFocused.focus();
    } else {
      btn.focus();
    }
  }

  panel.addEventListener('pointermove', function (e) {
    if (e.pointerType === 'mouse') {
      panel.classList.add('is-hovered');
    }
  });
  panel.addEventListener('pointerleave', function () {
    panel.classList.remove('is-hovered');
  });

  btn.addEventListener('click', openNav);
  closeBtn.addEventListener('click', closeNav);
  backdrop.addEventListener('click', closeNav);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  panel.querySelectorAll('button.side-nav-cat').forEach(function (catBtn) {
    catBtn.addEventListener('click', function () {
      const group = catBtn.closest('.side-nav-cat-group');
      const expanded = group.classList.toggle('is-expanded');
      catBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  });
}

function initScrollToTop(btn) {
  function update() {
    btn.classList.toggle('visible', window.scrollY > 400);
  }

  window.addEventListener('scroll', update, {passive: true});
  update();
}

function initTickerClose(bar, btn) {
  btn.addEventListener('click', function () {
    bar.style.display = 'none';
    localStorage.setItem('ticker-id', bar.dataset.tickerId);
  });
}

function initAuthorLoadMore(btn, list) {
  let loading = false;
  const wrap = btn.closest('.author-load-more');

  btn.addEventListener('click', function () {
    if (loading) return;

    const page = parseInt(btn.dataset.page, 10);
    const total = parseInt(btn.dataset.total, 10);
    const baseUrl = btn.dataset.url;

    if (!page || !baseUrl) return;

    loading = true;
    if (wrap) {
      wrap.classList.add('is-loading');
    }

    fetch(baseUrl + '?page=' + page, {headers: {'X-Requested-With': 'XMLHttpRequest'}})
      .then(function (res) {
        if (res.status === 204) return '';
        if (!res.ok) throw new Error('fetch failed');
        return res.text();
      })
      .then(function (html) {
        const trimmed = html.trim();

        if (trimmed) {
          const tmp = document.createElement('div');
          tmp.innerHTML = trimmed;

          while (tmp.firstChild) {
            list.appendChild(tmp.firstChild);
          }
        }

        const nextPage = page + 1;
        btn.dataset.page = nextPage;

        if (wrap) {
          wrap.classList.remove('is-loading');
        }

        if (!trimmed || nextPage > total) {
          if (wrap) {
            wrap.remove();
          } else {
            btn.remove();
          }
          return;
        }

        loading = false;
      })
      .catch(function () {
        if (wrap) {
          wrap.classList.remove('is-loading');
        }
        loading = false;
      });
  });
}
